
export const isString = (str: any) => {
  return typeof str === 'string'
}

export const lcFirst = (string: string) => {
  return string.charAt(0).toLowerCase() + string.slice(1)
}

export const ucFirst = (string: string | undefined) => {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : ''
}

export function splitOnCapitals(s: string): string[] {
  return s.split(/(?=[A-Z])/)
}

export const javaStringHash = (digest: any) => {
  let hash = 0;
  if (digest.length == 0) {
    return hash;
  }
  for (let i = 0; i < digest.length; i++) {
    const char = digest.charCodeAt(i);
    hash = ((hash<<5)-hash)+char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
}

export const toKebabCase = (str: string) =>
  str && str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)!
  .map(x => x.toLowerCase())
  .join('-')


export const splitNLetters = (str: string, n: number) => {
  const chunks: string[] = [];

  for (let i = 0, charsLength = str.length; i < charsLength; i += n) {
    chunks.push(str.substring(i, i + n));
  }

  return chunks
}

export const splitNLettersString = (str: string, n: number) => {
  return splitNLetters(str, n).join(' ')
}
